import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  TdDataTableService,
  TdDataTableSortingOrder,
  ITdDataTableSortChangeEvent,
  ITdDataTableColumn,
  TdDialogService,
  IPageChangeEvent
} from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { SettingsService } from '../../../../shared/services/settings.service';
import { Branch } from '../../../accounting/branch';
import { Observable } from 'rxjs/Observable';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-list-items',
  templateUrl: './list-items.component.html',
  styleUrls: ['./list-items.component.scss']
})
export class InvListItemsComponent implements OnInit {
  title: string;
  itemLocation: any;
  items: any[] = [];

  allBranches$: Observable<Branch[]>;

  branchFilter: number;

  columns: ITdDataTableColumn[] = [
    { name: 'collection_name', label: 'Collection', tooltip: '' },
    { name: 'design_name', label: 'Design', tooltip: '' },
    { name: 'color_name', label: 'Color', tooltip: '' },
    { name: 'length', label: 'Meters' },
    { name: 'piece_number', label: 'Piece Number', tooltip: '' },
    { name: 'lot_number', label: 'Lot Number' }
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dialogService: TdDialogService,
    public _settingsService: SettingsService,
    private _dataTableService: TdDataTableService,
    private location: Location,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
  ) { }

  ngOnInit(): void {
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  goBack(): void {
    this.location.back();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  findItems(location: string): void {
    this._inventoryService.findByLocation(location, this.branchFilter).subscribe(
      response => {
        this.items = response;
        console.log(this.items)
        this.filter();
      }
    );
  }

  totalPieces() {
    return this.items.length;
  }

  totalMeters() {
    return this.items.reduce((a, b) => { return a * 1 + b['length'] * 1 }, 0);
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.items;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;

    if (this.filteredTotal < 1) {
      this._dialogService.openAlert({
        message: 'No matching location found or location is empty!',
        title: 'Error'
      });
    }
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/list-items/list-items.component.ts